import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalConfirmComponent } from '@shared/generic-modals/modal-confirm.component';

// models
import { Aeroplanta } from '@shared/models/despacho';
import { PointSmart } from '@shared/models/facturacion';

// services
import { MessageService } from '@shell/message.service';
import { ComprobanteService } from '@facturacion/comprobante.service';

@Component({
  selector: 'app-modal-posnet',
  templateUrl: './modal-posnet.component.html',
  styleUrls: ['./modal-posnet.component.scss']
})
export class ModalPosnetComponent implements OnInit {

  guardando: boolean = false;
  cargandoPoints: boolean = false;
  formPosnet: FormGroup;
  pointSmart: PointSmart[] = [];
  listPoints: PointSmart[] = [];
  aeroplantaSeleccionada: Aeroplanta;
  createPoint: boolean = true;

  constructor(
    private activeModal: NgbActiveModal,
    private modal: NgbModal,
    private formBuilder: FormBuilder,
    private messageService: MessageService,
    private comprobanteService: ComprobanteService
  ) {

  }

  ngOnInit(): void {
    this.setFormInit();
    this.listPoints = this.pointSmart.map(point => ({ ...point }));
    this.createPoint = this.listPoints.length == 0;
    this.initArray();
  }

  setFormInit() {
    this.formPosnet = this.formBuilder.group({
      aliasFormControl: [{value: '', disabled: false}, Validators.required],
      numeroFormControl: [{value: '', disabled: false}, [Validators.required, Validators.maxLength(10)]],
      activoFormControl: [{value: ''}]
    })
  }

  initArray() {
    this.listPoints.map(p => p._modificado = false);
    this.listPoints.forEach(p => this.activoFormControl.setValue(p.activo));
  }

  onCheck(i, value) {
    this.listPoints.forEach((p, index) => {
      if (index === i) {
        p.activo = value;
        p._modificado = true;
      }
    });
  }

  existPoint(alias: string, nroPoint: string) {
    const exist = this.listPoints.some(p => p.alias.toLowerCase() == alias.toLowerCase() || p.nroPoint == nroPoint);
    return exist;
  }

  addPoint() {
    if (this.formPosnet.valid) {
      if (!this.existPoint(this.aliasFormControl.value, this.numeroFormControl.value)) {
        const newPoint = new PointSmart();
        newPoint.codigoAeroplanta = this.aeroplantaSeleccionada.codigoAeroplanta;
        newPoint.alias = this.aliasFormControl.value.toUpperCase();
        newPoint.nroPoint = this.numeroFormControl.value;
        newPoint.activo = true;
        newPoint._modificado = true;
        console.log(newPoint);
        this.listPoints.push(newPoint);
        this.formPosnet.reset();
      } else {
        this.messageService.showErrorMessage('El Alias o Número de Point ya se encuentra cargado. Verifique');
      }

    }
  }

  borrarPoint(p: PointSmart) {
    const index = this.listPoints.findIndex(x => x.nroPoint == p.nroPoint);
    this.listPoints.splice(index, 1);
  }

  async savePoint() {
    if (this.listPoints.length == 0) {
      this.messageService.showErrorMessage('Debe agregar al menos un point smart.');
      return;
    }

    if (!this.createPoint && !this.alert) {
      this.messageService.showWarningMessage('No hay cambios para guardar.', false);
      return;
    }

    this.guardando = true;
    let request;
    try {
      (this.createPoint) ? request = await this.comprobanteService.postGuardarNuevosDispositivosPoint(this.listPoints) :
                          request = await this.comprobanteService.putModificarDispositivosPoint(this.listPoints);

      if (request === true) {
        this.messageService.showSuccessMessage(`Point smart ${this.createPoint ? 'creados' : 'modificados'} con éxitos.`);
        this.onClose(true);
      } else {
        this.messageService.showErrorLongMessage(`Error en la ${this.createPoint ? 'creación' : 'modificación'} de point smart.`);
      }
      this.guardando = false;
    } catch (error) {
      this.messageService.showErrorLongMessage(`Error en la ${this.createPoint ? 'creación' : 'modificación'} de point smart. \n ${error.description ?? ""}`);
      this.guardando = false;
    }
  }

  onClose(val?: boolean) {
    if (this.alert && !val) {
      const modalRef = this.modal.open(ModalConfirmComponent, { centered: true });
      modalRef.componentInstance.mensaje = "¿Confirma salir sin guardar cambios?";
      modalRef.result.then(() => {
        this.activeModal.close();
      });
    } else {
      this.activeModal.close();
    }
  }

  get alert() {
    return this.listPoints.some(p => p._modificado);
  }

  get aliasFormControl() {
    return this.formPosnet.controls.aliasFormControl;
  }

  get numeroFormControl() {
    return this.formPosnet.controls.numeroFormControl;
  }

  get activoFormControl() {
    return this.formPosnet.controls.activoFormControl;
  }
}
